<div
    class="app-input"
    [ngClass]="[size, customClass]">

    <input
        type="text"
        [placeholder]="placeholder"
        [attr.maxlength]="maxlength"
        [value]="value"
        [attr.inputmode]="onlyNumbers ? 'numeric' : null"
        (keydown)="allowCtrlKeys($event)"
        (input)="onInput($event)"/>
</div>
